import { useState } from "react";
import { useTimeout } from "./useTimeout";

export const useDelay = delayMs => {
    const [triggered, setTriggered] = useState(false);
    useTimeout(() => setTriggered(true), delayMs);
    return triggered;
};
